import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#032E32",
      d: "M11 5.408a1.924 1.924 0 1 1 0 3.85 1.924 1.924 0 0 1 0-3.85m0 8.25c2.723 0 5.592 1.339 5.592 1.925v1.009H5.408v-1.009c0-.586 2.87-1.925 5.592-1.925m0-9.991a3.666 3.666 0 0 0-3.667 3.666A3.666 3.666 0 0 0 11 11a3.666 3.666 0 0 0 3.667-3.667A3.666 3.666 0 0 0 11 3.667m0 8.25c-2.447 0-7.333 1.228-7.333 3.666v2.75h14.666v-2.75c0-2.438-4.885-3.666-7.333-3.666"
    }, null, -1)
  ]))]))
}
export default { render: render }